import AbstractClient from './AbstractClient'
import CrudBuilder from './CrudBuilder'
import store from 'store'
import Clonable from './mock/clonable.json'

class Table extends AbstractClient {
  getAll (model) {
    return super.get(`/${model}`)
  }

  getByRole (model, mapper) {
    const isImpersonate = store.getters['session/isImpersonate']
    if (!store.getters['auth/isAdmin'] || isImpersonate) {
      const crudBuilder = new CrudBuilder(mapper)
      return super.get(`/${model}/` + crudBuilder.build(true))
    }
    return this.getAll(model)
  }

  get (model, id) {
    return super.get(`/${model}/${id}`)
  }

  add (model, data) {
    return super.post(`/${model}`, data)
  }

  update (model, id, data) {
    return super.put(`/${model}/${id}`, data)
  }

  delete (model, id) {
    return super.delete(`/${model}/${id}`)
  }

  clone (model, id, data) {
    return super.post(`/${model}/${id}/clone`, data)
  }

  getSelect (url) {
    return super.get(`/${url}`)
  }

  getSelects (model, id, mapper) {
    const crudBuilder = new CrudBuilder(mapper)
    const currId = id || 0
    return super.post(`/${model}/${currId}/select`, crudBuilder.build(false))
  }

  getClonable () {
    return Clonable
  }

  uploadRemove (data, id) {
    return super.delete(`/upload/remove/${id}`, data)
  }
}

export default new Table()
